<template>
  <v-container id="featuresSection" class="text-center pa-0" fluid>
    <div class="heading-h1 mb-3">Easi does it better</div>
    <v-row class="overview-container py-0">
      <v-col v-for="({ image, title, text }, i) in features" :key="i" cols="12" md="4">
        <v-card class="py-12" flat tile>
          <v-img class="my-2" :src="image" :alt="title" height="110" contain />
          <p class="body-heading-medium">{{ title }}</p>
          <div class="text-md-left text-center">{{ text }}</div>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: "FeatureSection",
    data() {
      return {
        features: [
          {
            image: require("@/assets/feature-section-icon-1.jpg"),
            title: "Peppier than a piggybank",
            text: "Allowances are swell but go in a flash. Get your kid’s butts moving with stuff they really want.",
          },
          {
            image: require("@/assets/feature-section-icon-2.jpg"),
            title: "Collecting points is fun",
            text: "Like a flight on free miles, you know earning rewards feels great. We even send progress nudges!",
          },
          {
            image: require("@/assets/feature-section-icon-3.jpg"),
            title: "Quietly educational",
            text: "Chores are a bore but good habits start early. Teach valuable life lessons with way less hassle.",
          },
        ],
      };
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/LandingPage/FeatureSection.vue